import VirtualPath from 'meta/utils/virtualPath'
import Api from 'meta/features/api'

const API_PATH = `${VirtualPath}/webapi`
const api = Api({
    baseURL: `${API_PATH}/audit`,
    parseDateStrings: true
})

export default {
  /**
   * Submits an audit message with action as a single string.
   * @param {string} application the App (for example RX, CPOE, eMAR)
   * @param {string} menuItem menu item (for example Scheduled Processes, Order Entry, Print Controller Query)
   * @param {string} action action (for example View, Show Patient Profile) - usually text on the button
   * @param {string} type string parsable to the AuditBO.enaType enum (for example Save, View, DC, Hold, Delete); leave at 'None' for actions which are only UI clicks and therefore not worth having their own enum value in AuditBO
   * @param {object} properties keys to other related entities like orders
   */
    writeSimpleAction(application, menuItem, action, type = 'None', properties = {ordNo: null, account: null}) {
      let actionWithData = {}
      actionWithData[action] = null
      return api.post('/action', {application, menuItem, actionWithData, type, ...properties})
    },

    /**
     * Submits an audit message with key value pairs describing the action. Use when data changes need to be audited.
     * @param {string} application the App (for example RX, CPOE, eMAR)
     * @param {string} menuItem menu item (for example Scheduled Processes, Order Entry, Print Controller Query)
     * @param {object} actionWithData key value pairs about the action (for example {Select recent patient: Shy, Celena} or {Data for patient changed, Visit Account#: 111111, VisName: Celer})
     * @param {string} type string parsable to the AuditBO.enaType enum (for example Save, View, DC, Hold, Delete); leave at 'None' for actions which are only UI clicks and therefore not worth having their own enum value in AuditBO
     * @param {object} properties keys to other related entities like orders
     */
    writeDataAction(application, menuItem, actionWithData, type = 'None', properties = {ordNo: null, account: null}) {
      return api.post('/action', {application, menuItem, actionWithData, type, ...properties})
  }
}
